import { render, staticRenderFns } from "./LegendDropdown.vue?vue&type=template&id=8d94c55e&scoped=true&"
import script from "./LegendDropdown.vue?vue&type=script&lang=js&"
export * from "./LegendDropdown.vue?vue&type=script&lang=js&"
import style0 from "./LegendDropdown.vue?vue&type=style&index=0&id=8d94c55e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d94c55e",
  null
  
)

export default component.exports